import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSimCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sim-card-2"} maskId="square-filled-radius-0-stroke-1-IconSimCard2"><path d="M20 2V22H4V6.29289L8.29289 2H12V8H13V2H16V8H17V2H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSimCard2;
